import {
  FilterMode,
  UserAttachmentEdition_OrderBy,
  UserAttachmentEdition,
  SortOrder,
  UserAttachmentEdition_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const userAttachmentEditionService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.userAttachmentEditionOne({ id });
    return result.userAttachmentEditionOne as UserAttachmentEdition;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: UserAttachmentEdition_OrderBy[] | null = null,
    filter: UserAttachmentEdition_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: UserAttachmentEdition_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.userAttachmentEditionListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.userAttachmentEditionListWithOffset
    ) as UserAttachmentEdition[];
    return { list, orderBy };
  },
};
